import { render, staticRenderFns } from "./nameTag.vue?vue&type=template&id=e9b4a96c&scoped=true&"
import script from "./nameTag.vue?vue&type=script&lang=js&"
export * from "./nameTag.vue?vue&type=script&lang=js&"
import style0 from "./nameTag.vue?vue&type=style&index=0&id=e9b4a96c&lang=scss&scoped=true&"
import style1 from "./nameTag.vue?vue&type=style&index=1&lang=scss&"
import style2 from "./nameTag.vue?vue&type=style&index=2&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9b4a96c",
  null
  
)

export default component.exports